import React from 'react';
import { FolderInput, Brain, FlaskConical, BookMarked } from 'lucide-react';

const STEPS = [
  {
    icon: FolderInput,
    title: 'Drop your PDF pile',
    body:
      'Point Sortio at your Downloads folder, your Zotero storage directory, or any folder of downloaded papers. Preprints, conference proceedings, dissertation chapters, supplemental data, slide decks: anything you drag in.',
  },
  {
    icon: Brain,
    title: 'Read title, authors, DOI, year',
    body:
      'Sortio parses each PDF for the title, first author, year, journal or conference, DOI, and abstract. Optionally enriches against Crossref to fix sparse metadata in older OCR\'d scans. All inference can run locally with Ollama so unpublished work never leaves your machine.',
  },
  {
    icon: FlaskConical,
    title: 'Route by project and collection',
    body:
      'Each paper lands in the right project folder (PhD thesis, current grant, lit review, collaboration with X). The Rule Builder lets you express things like "if the abstract mentions transformer architectures, route under deep-learning/2023+ and tag for the methods chapter."',
  },
  {
    icon: BookMarked,
    title: 'Sync to Zotero',
    body:
      'When the Zotero integration ships in the next release, files routed to a project upload directly into the matching Zotero collection as an item with attachment. Metadata is preserved, citation key is generated, and your library stays the canonical reference.',
  },
];

const Workflow = () => {
  return (
    <section id="workflow" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          How academic file organization works
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          Four steps from a Downloads folder of unnamed PDFs to a clean project library synced
          with Zotero.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {STEPS.map((step, i) => {
          const Icon = step.icon;
          return (
            <div key={i} className="relative bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6 flex flex-col">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 rounded-full bg-sortio-primary/15 border border-sortio-primary/30 flex items-center justify-center mr-3">
                  <Icon className="text-sortio-primary" size={18} />
                </div>
                <span className="text-xs font-medium uppercase tracking-wider text-apple-400">Step {i + 1}</span>
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-2">{step.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{step.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Workflow;
